<template>
	<main class="mypage notice">
		<article class="notice_info">
			<h6>공지사항</h6>
			<div v-if="getBannerMulti?.notice" class="banner">
				<SubSwiperSlide v-if="!isBannerLoading" :data="getBannerMulti?.notice ?? []" />
			</div>
			<section>
				<div class="tabMenu">
					<div
						class="tabMenu_item"
						:class="{ on: currentTab === '공지사항' }"
						@click="$router.replace({ query: { currentTab: '공지사항', page: 1 } })"
					>
						<div class="tabMenu_item_img">
							<IconBase width="38" height="38" view-box="0 0 38 38" icon-name="공지사항">
								<IconSpeakerTap :icon-color="currentTab === '공지사항' ? '#FF6C00' : '#818393'" />
							</IconBase>
						</div>
						<p>공지사항</p>
					</div>
					<div
						class="tabMenu_item"
						:class="{ on: currentTab === '필독' }"
						@click="$router.replace({ query: { currentTab: '필독', page: 1 } })"
					>
						<div class="tabMenu_item_img">
							<IconBase width="38" height="38" view-box="0 0 38 38" icon-name="필독">
								<IconExclamation :icon-color="currentTab === '필독' ? '#FF6C00' : '#818393'" />
							</IconBase>
						</div>
						<p>필독</p>
					</div>
					<div
						class="tabMenu_item"
						:class="{ on: currentTab === '이벤트' }"
						@click="$router.replace({ query: { currentTab: '이벤트', page: 1 } })"
					>
						<div class="tabMenu_item_img">
							<IconBase width="38" height="38" view-box="0 0 38 38" icon-name="이벤트">
								<IconGift :icon-color="currentTab === '이벤트' ? '#FF6C00' : '#818393'" />
							</IconBase>
						</div>
						<p>이벤트</p>
					</div>
				</div>
				<ul class="history_board">
					<li
						v-for="(item, index) in getMasterList?.mustread"
						:key="index"
						class="history_board_item"
						@click="router.push({ path: `/notice-detail/${item.mustread_pk}` })"
					>
						<div class="history_board_title">
							<span v-if="currentTab === '공지사항'" class="c_tag color-red noticeTag">공지</span>
							<p>
								{{ item.mustread_title }}
							</p>
						</div>

						<p>{{ item.mustread_enrollment_date }}</p>
					</li>
				</ul>
				<Pagination
					v-if="getMasterList?.mustread_count"
					:current-page="Number(route.query.page ?? 1)"
					:total-count="getMasterList?.mustread_count ? Math.ceil(getMasterList?.mustread_count / 10) : 0"
					@set-page="(page) => router.replace({ query: { ...route.query, page: page } })"
				/>
			</section>
		</article>
	</main>
	<HomePopup exposure-location="notice" />
</template>

<script setup lang="ts">
// lib
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useGetBannerMultiApi } from '@/api/banner';
// api
import { useGetMustreadListDataApi } from '@/api/notice';
import IconBase from '@/components/atom/icon/IconBase.vue';
import IconExclamation from '@/components/atom/icon/IconExclamation.vue';
// store
import IconGift from '@/components/atom/icon/IconGift.vue';
import IconSpeakerTap from '@/components/atom/icon/IconSpeakerTap.vue';
import HomePopup from '@/components/popup/HomePopup.vue';
// component
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';

// -----variable-----
const route = useRoute();
const router = useRouter();

const currentTab = computed(() => {
	return (route.query.currentTab ?? '공지사항') as string;
});
// -----api-----
const { data: getMasterList } = useGetMustreadListDataApi(
	computed(() => {
		return {
			notice_division: currentTab.value,
			page: Number(route.query.page ?? 1),
			view: 10,
		};
	})
);
const { data: getBannerMulti, isLoading: isBannerLoading } = useGetBannerMultiApi({ type: 'notice' });
</script>

<style lang="scss" scoped>
.notice {
	max-width: 68rem;
	width: 100%;
	margin: 7.2rem auto;
	@media screen and (max-width: 1280px) {
		margin: 7.2rem auto 8rem;
	}
	.notice_info {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: var(--space-xxx-large);
		.banner {
			@media screen and (max-width: 1280px) {
				padding: 0rem;
			}
		}
		.tabMenu {
			white-space: nowrap;
			display: flex;
			text-align: center;
			gap: 1rem;
			margin-bottom: 2.4rem;
			overflow: hidden;
			.tabMenu_item {
				min-width: 0;
				overflow: hidden;
				flex: 1;
				background-color: var(--color-bg-mid);
				border-radius: var(--space-x-small);
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				gap: var(--space-x-small);
				padding: 2rem 0rem;
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-medium);
				height: 10.7rem;
				cursor: pointer;
				&_img {
					width: 3.8rem;
					height: 3.8rem;
					flex-shrink: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					svg {
						width: 100%;
						height: 100%;
					}
				}
				&.on {
					border: 1px solid var(--color-primary);
					color: var(--color-primary);
				}
			}
		}
		.history_board {
			padding: 0rem;
			&_item {
				cursor: pointer;
				.history_board_title {
					display: flex;
					gap: 0.8rem;
					p {
						display: inline-block;
						max-width: 55rem;
						width: 100%;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
						color: var(--color-base-white);
						font-weight: var(--font-w-light);
						line-height: 1.9rem;
					}
				}
			}
		}
	}
}
.noticeTag {
	height: 2rem;
}
</style>
